export function excludeUnchangedTokenBalances(currentTokenBalances, newTokenBalancePairs) {
  const newTokenBalances = Object.fromEntries(newTokenBalancePairs)

  return newTokenBalancePairs.reduce((tokenBalancesAcc, [token, balance]) => {
    const currentBalance = currentTokenBalances[token]
    if (!newTokenBalances[token].isZero || (currentBalance && !currentBalance.isZero)) {
      tokenBalancesAcc[token] = balance
    }

    return tokenBalancesAcc
  }, {})
}
